// Generated by Claude Code
import { WorkOrderDetailPanel } from '#components/domain/operations/work-orders/work-order-detail/index.tsx'
import { WorkOrderEditDrawer } from '#components/domain/operations/work-orders/shared/work-order-edit/work-order-edit-drawer.tsx'
import { PermissionGuard } from '#components/tools/permission-guard.tsx'
import { PermissionService } from '#core/entities/auth/roles/Permission.ts'
import { readAnyGroups } from '#core/entities/auth/roles/permission-gate-helpers.ts'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export const Route = createFileRoute('/_app/$companyId/work-orders/$workOrderId')({
  component: RouteComponent,
  staticData: {
    title: 'Work Order Detail',
  },
})

function RouteComponent() {
  return (
    <PermissionGuard permissions={readAnyGroups(PermissionService.WORK_ORDERS)} redirectOnNotAuthorized>
      <WorkOrderDetailPageContent />
    </PermissionGuard>
  )
}

function WorkOrderDetailPageContent() {
  const { companyId, workOrderId } = Route.useParams()
  const navigate = useNavigate()
  const { t } = useTranslation('work-orders')

  const [editOpen, setEditOpen] = useState(false)
  const [reloadKey, setReloadKey] = useState(0)

  function handleBack() {
    void navigate({ to: '/$companyId/work-orders', params: { companyId } })
  }

  return (
    <div className="container-fluid d-flex flex-column h-100 py-3">
      <div className="row justify-content-center flex-grow-1">
        <div className="col-12 col-lg-10 col-xl-8 d-flex flex-column">
          <div className="mb-2">
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary d-inline-flex align-items-center gap-1"
              onClick={handleBack}
            >
              <ArrowLeft size={14} />
              {t('shared.actions.backToList')}
            </button>
          </div>
          <div className="flex-grow-1 overflow-hidden card rounded-3 p-0">
            <WorkOrderDetailPanel
              workOrderId={workOrderId}
              onClose={handleBack}
              onEdit={() => setEditOpen(true)}
              reloadKey={reloadKey}
            />
          </div>
        </div>
      </div>

      <WorkOrderEditDrawer
        isOpen={editOpen}
        workOrderId={workOrderId}
        onClose={() => setEditOpen(false)}
        onUpdated={() => { setEditOpen(false); setReloadKey((k) => k + 1) }}
      />
    </div>
  )
}
